<template>
  <div class="mobile-container">
    <TopTitle/>
    <div class="trace-bar-code-main-content">
      <div class="trace-bar-code-activity">
        <div class="trace-bar-code-top-title">商品溯源信息如下</div>
        <div class="context-info-div">
          <span class="title-width">名称</span>：博望黄金梨<br/>
          <span class="title-width">规格</span>： 300g<br/>
          <span class="title-width">产地</span>：博望镇黄金梨果园A103树<br/>
          <span class="title-width">采摘日期</span>：20205年11月30日<br/>
          <span class="title-width">质量检测</span>：优等品<br/>
        </div>
      </div>
      <div class="br-line-spacing-padding">
        <!--用于填充图片和文字的空白框-->
      </div>
      <img class="trace-bar-code-img" src="../resource/traceBarCode.jpg">
    </div>
  </div>
</template>

<script setup>
import {onMounted} from 'vue';
import {ElNotification} from "element-plus";
// import {useRouter} from 'vue-router';

// eslint-disable-next-line
defineOptions({
  name: 'OrganizeActivity'
});

// eslint-disable-next-line
const handleBuyNow = (product) => {
  // 直接调用 ElNotification，无需模板标签
  ElNotification({
    title: '预约提示',
    message: `即将为您预约：${product}`,
    type: 'info',
    duration: 2000,
    showClose: true
  });
};
onMounted(() => {
  // user.value = JSON.parse(sessionStorage.getItem("loginUser"));
  // 添加触摸事件支持
});
</script>

<style scoped>
/* 可选：清除默认边距，避免滚动异常 */
body, html {
  margin: 0;
  padding: 0;
}

/* 基础样式 */
.mobile-container {
  height: 93vh;
  width: 100vw;
  position: fixed;
  overflow-y: auto;
  /* 隐藏横向滚动条（防止意外横向滚动） */
  overflow-x: hidden;
  /* 可选：优化滚动体验（iOS端） */
  /*background: linear-gradient(to bottom right, #33872B, #d8ffd0);*/
  background-color: #F2F2E8; /* 白色*/
  /*background-color: #33872B;*//* 绿色*/
  /*background-color: #EAF0E6;*/ /* 黄白色*/
  /* 可选：子元素之间的间距（按需调整） */
  gap: 5px;
  /*  display: flex;
    flex-direction: column;
    align-items: flex-start; !* 垂直顶部对齐 *!
    justify-content: right; !* 水平左对齐 *!*/
  top: 0;
  left: 0;
}

/*整体页面的缩进和填充*/
.trace-bar-code-main-content {
  margin-top: 1vh;
  margin-left: 2vw;
  margin-right: 2vw;
}

/*主要内容*/
.trace-bar-code-activity {
  align-items: center; /* 垂直顶部对齐 */
  justify-content: left; /* 水平左对齐 */
  border: 1px solid #999999;
  border-radius: 5px;
  width: auto;
  height: auto;
  margin-left: 5vw;
  margin-right: 5vw;
  padding-top: 2vh;
  padding-bottom: 2vh;
}

.trace-bar-code-top-title {
  font-weight: bold; /* 加粗 */
  font-size: 20px;
  margin-left: 5vw;
  text-align: left;
  /*align-items: flex-start; !* 垂直顶部对齐 *!*/
  justify-content: left; /* 水平左对齐 */
  margin-bottom: 1vh;
}

.title-width {
  display: inline-block; /* 关键：让span支持宽度设置，且不独占一行 */
  width: 75px; /* 固定宽度（按需调整，比如70px更紧凑，90px更宽松） */
  text-align: justify; /* 文本右对齐，冒号统一靠右侧 */
  text-align-last: justify; /* 单行文本两端对齐（兼容所有场景） */
  vertical-align: top; /* 可选：防止多行内容时对齐偏移 */
  font-weight: 500; /* 可选：给标题加一点粗，区分标题和内容 */
  white-space: nowrap; /* 防止标题文字换行 */
}

.context-info-div {
  font-size: 18px;
  margin-left: 5vw;
  text-align: left;
  line-height: 1.8;
}

/*行间距*/
.br-line-spacing-padding {
  height: 2vh;
}

.trace-bar-code-img {
  width: 100%;
  border-radius: 5px;
}

</style>